(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bests-selling-upgrades"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aad-best-selling')) {
    customElements.define(
      'aad-best-selling',
      class AADBestSelling extends HTMLElement {
        connectedCallback() {
          if (this._ready) {
            if (this._resizeHandler) {
              window.addEventListener(
                'resize',
                this._resizeHandler,
                { passive: true }
              );
            }

            if (this._blockSelectHandler) {
              document.addEventListener(
                'shopify:block:select',
                this._blockSelectHandler
              );
            }

            this.updateNavigation();
            return;
          }

          this._ready = true;

          this.tabs = Array.from(
            this.querySelectorAll('[data-tab-button]')
          );

          this.panels = Array.from(
            this.querySelectorAll('[data-tab-panel]')
          );

          this.previousButton = this.querySelector(
            '[data-rail-previous]'
          );

          this.nextButton = this.querySelector(
            '[data-rail-next]'
          );

          this._scrollFrame = null;

          this.tabs.forEach((tab, index) => {
            tab.addEventListener(
              'click',
              () => this.activateTab(index)
            );

            tab.addEventListener(
              'keydown',
              (event) => this.handleTabKeydown(event, index)
            );
          });

          if (this.previousButton) {
            this.previousButton.addEventListener(
              'click',
              () => this.moveRail(-1)
            );
          }

          if (this.nextButton) {
            this.nextButton.addEventListener(
              'click',
              () => this.moveRail(1)
            );
          }

          this.querySelectorAll('[data-product-rail]').forEach((rail) => {
            rail.addEventListener(
              'scroll',
              () => this.requestNavUpdate(),
              { passive: true }
            );
          });

          this.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
            this.initializeGallery(gallery);
          });

          this._resizeHandler = () => this.requestNavUpdate();

          window.addEventListener(
            'resize',
            this._resizeHandler,
            { passive: true }
          );

          this._blockSelectHandler = (event) => {
            if (!event.detail || !event.detail.blockId) return;

            const selectedTab = this.tabs.find(
              (tab) => tab.dataset.blockId === event.detail.blockId
            );

            if (!selectedTab) return;

            this.activateTab(this.tabs.indexOf(selectedTab));

            selectedTab.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          };

          document.addEventListener(
            'shopify:block:select',
            this._blockSelectHandler
          );

          this.updateNavigation();
        }

        disconnectedCallback() {
          if (this._resizeHandler) {
            window.removeEventListener(
              'resize',
              this._resizeHandler
            );
          }

          if (this._blockSelectHandler) {
            document.removeEventListener(
              'shopify:block:select',
              this._blockSelectHandler
            );
          }

          if (this._scrollFrame) {
            cancelAnimationFrame(this._scrollFrame);
          }
        }

        getActivePanel() {
          return this.panels.find((panel) => !panel.hidden);
        }

        getActiveRail() {
          const panel = this.getActivePanel();

          return panel
            ? panel.querySelector('[data-product-rail]')
            : null;
        }

        activateTab(index, moveFocus = false) {
          if (!this.tabs[index]) return;

          this.tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === index;

            tab.classList.toggle('is-active', isActive);
            tab.setAttribute(
              'aria-selected',
              isActive ? 'true' : 'false'
            );
            tab.tabIndex = isActive ? 0 : -1;
          });

          this.panels.forEach((panel, panelIndex) => {
            panel.hidden = panelIndex !== index;
          });

          if (moveFocus) {
            this.tabs[index].focus();
          }

          const activeRail = this.getActiveRail();

          if (activeRail) {
            activeRail.scrollLeft = 0;

            if (this.previousButton) {
              this.previousButton.setAttribute(
                'aria-controls',
                activeRail.id
              );
            }

            if (this.nextButton) {
              this.nextButton.setAttribute(
                'aria-controls',
                activeRail.id
              );
            }
          }

          requestAnimationFrame(
            () => this.updateNavigation()
          );
        }

        handleTabKeydown(event, index) {
          if (!this.tabs.length) return;

          let newIndex = index;

          if (event.key === 'ArrowRight') {
            newIndex = (index + 1) % this.tabs.length;
          } else if (event.key === 'ArrowLeft') {
            newIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          } else if (event.key === 'Home') {
            newIndex = 0;
          } else if (event.key === 'End') {
            newIndex = this.tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          this.activateTab(newIndex, true);
        }

        moveRail(direction) {
          const rail = this.getActiveRail();

          if (!rail) return;

          const firstCard = rail.querySelector('.aad-bsu__card');
          const railStyles = window.getComputedStyle(rail);
          const railGap =
            parseFloat(railStyles.columnGap || railStyles.gap) || 0;

          const distance = firstCard
            ? firstCard.getBoundingClientRect().width + railGap
            : Math.max(260, rail.clientWidth * 0.86);

          const reduceMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

          rail.scrollBy({
            left: direction * distance,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        }

        requestNavUpdate() {
          if (this._scrollFrame) {
            cancelAnimationFrame(this._scrollFrame);
          }

          this._scrollFrame = requestAnimationFrame(
            () => this.updateNavigation()
          );
        }

        updateNavigation() {
          const rail = this.getActiveRail();

          if (
            !rail ||
            !this.previousButton ||
            !this.nextButton
          ) {
            return;
          }

          const maxScroll = Math.max(
            0,
            rail.scrollWidth - rail.clientWidth
          );

          const atStart = rail.scrollLeft <= 2;
          const atEnd = rail.scrollLeft >= maxScroll - 2;

          this.previousButton.disabled = atStart;
          this.nextButton.disabled = maxScroll <= 2 || atEnd;

          this.previousButton.setAttribute(
            'aria-controls',
            rail.id
          );

          this.nextButton.setAttribute(
            'aria-controls',
            rail.id
          );
        }

        initializeGallery(gallery) {
          const images = Array.from(
            gallery.querySelectorAll('[data-product-image]')
          );

          const dots = Array.from(
            gallery.querySelectorAll('[data-gallery-dot]')
          );

          const status = gallery.querySelector(
            '[data-gallery-status]'
          );

          if (!images.length) return;

          let currentIndex = 0;

          const showImage = (newIndex) => {
            currentIndex =
              (newIndex + images.length) % images.length;

            images.forEach((image, index) => {
              const isActive = index === currentIndex;

              image.classList.toggle('is-active', isActive);

              image.setAttribute(
                'aria-hidden',
                isActive ? 'false' : 'true'
              );
            });

            dots.forEach((dot, index) => {
              dot.classList.toggle(
                'is-active',
                index === currentIndex
              );
            });

            if (status) {
              const productTitle =
                status.dataset.productTitle || 'product';

              status.textContent =
                `Image ${currentIndex + 1} of ${images.length} for ${productTitle}`;
            }
          };

          showImage(0);

          const previous = gallery.querySelector(
            '[data-image-previous]'
          );

          const next = gallery.querySelector(
            '[data-image-next]'
          );

          if (previous) {
            previous.addEventListener(
              'click',
              () => showImage(currentIndex - 1)
            );
          }

          if (next) {
            next.addEventListener(
              'click',
              () => showImage(currentIndex + 1)
            );
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
